import React, { useEffect, useMemo, useState } from "react"
import { promoCampaign } from "./constants"
import Link from "../link"

export const ImageBar = ({ campaign }: { campaign: string }) => {
  const campaignData = useMemo(() => {
    if (!promoCampaign.image[campaign]) {
      return null
    }

    return promoCampaign.image[campaign].images
  }, [campaign])

  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 1024)
    }

    checkMobile()
    window.addEventListener("resize", checkMobile)

    return () => {
      window.removeEventListener("resize", checkMobile)
    }
  }, [])

  if (!campaignData) {
    return <></>
  }

  const imageLink = isMobile
    ? campaignData.mobileLink
    : campaignData.desktopLink

  return (
    <div className="w-full h-full bg-white flex justify-center items-center overflow-hidden">
      <Link target="_blank" to={imageLink || campaignData.desktopLink} external>
        <picture>
          <source
            media="(min-width: 768px)"
            srcSet={`/static-images/hello-bars/${campaignData.desktop}`}
          />
          <source
            media="(max-width: 767px)"
            srcSet={`/static-images/hello-bars/${campaignData.mobile}`}
          />
          <img
            src={`/static-images/hello-bars/${campaignData.desktop}`}
            alt={campaignData.title}
            className="2xl:w-[1440px] w-full 2xl:h-[56px] h-auto"
          />
        </picture>
      </Link>
    </div>
  )
}
